import React from "react";
import { Row, Col, ControlLabel, FormGroup, FormControl, Button, Alert, HelpBlock } from 'react-bootstrap';
import LineHorizontal from '../components/LineHorizontal.js'
import "./contact.css";
import axios from 'axios';

export default class Contact extends React.Component {
  constructor(props) {
    super(props);
 
    this.state = {
      formSubmitted: false,
      nameError: false,
      emailError: false,
      messageError: false,
    };
  }

  formSubmit(event) {
    event.preventDefault();
   
    let form = document.querySelector('form') 

    let name = this.nameRef.value
    let email = this.emailRef.value
    let message = this.messageRef.value
   
    var nameCheck = true;
    var emailCheck = true;
    var messageCheck = true;

    if (name === "") {
      nameCheck = true;
    } else {
      nameCheck = false;
    }

    if (email === "") {
      emailCheck = true;
    } else if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      emailCheck = false;
    } else {
      emailCheck = true;
    }

    if (message === "") {
      messageCheck = true;
    } else {
      messageCheck = false;
    }

    if (nameCheck === true || emailCheck === true || messageCheck === true) {
      console.log("error");
      this.setState({
        nameError: nameCheck,
        emailError: emailCheck,
        messageError: messageCheck,
      });
    } else {
      this.setState({
        nameError: false,
        emailError: false,
        messageError: false,
      });

      axios.post("http://formspree.io/acrow@crowtech.com.au", {
          name: name,
          email: email,
          message: message
      })
      .then(function (response) {
        console.log(response);
        form.reset()
      })
      .catch(function(error) {
        console.log(error);
        form.reset()
      });
      this.setState({ formSubmitted: true, }, () => { console.log(this.state.formSubmitted); });
    }
  }

  render() {

    return (
      <Row>
        <Col md={12}>
          <h2 className="text-center">Contact Crowtech</h2>
        </Col>
        <Col md={12}>
          <LineHorizontal/>
        </Col>
        <Col mdOffset={1} md={10}>
          <p>Email: acrow@crowtech.com.au</p>
          <p>ABN: 82 145 623 575</p>
          <p>Phone: 0434 321 230</p>
        </Col>
        <Col mdOffset={1} md={10}>
          <p>If you are interested in having Crowtech consult on your project, or if you have any other inquiries, please fill out the form below with your details. We will review your email and get back to you as soon as we can.</p>
        </Col>

        { this.state.formSubmitted
        ?
        <Col mdOffset={1} md={10}>
          <Alert bsStyle="success">
            Thanks for you message, we will be in contact as soon as we can.
          </Alert>
        </Col>
        :
        <Col md={6} mdOffset={3}>

          <form onSubmit={ event => { this.formSubmit(event) } }>
            
            <FormGroup
              validationState={this.state.nameError ? 'error' : null}
            >
              <ControlLabel>Name</ControlLabel>
              <FormControl
                inputRef={(input) => this.nameRef = input }
                type="text"
                name="name"
                placeholder="Enter your name here."
              />
              <HelpBlock>{this.state.nameError ? "Please enter a name." : ''}</HelpBlock>
            </FormGroup>

            <FormGroup
              validationState={this.state.emailError ? 'error' : null}
            >
              <ControlLabel>Email</ControlLabel>
              <FormControl
                inputRef={(input) => this.emailRef = input }
                type="email"
                name="email"
                placeholder="Enter your email here."
              />
              <HelpBlock>{this.state.emailError ? "Please enter an email address." : ''}</HelpBlock>
            </FormGroup>

            <FormGroup
              validationState={this.state.messageError ? 'error' : null}
            >
              <ControlLabel>Message</ControlLabel>
              <FormControl
                inputRef={(input) => this.messageRef = input }
                name="message"
                componentClass="textarea"
                placeholder="Enter your message here."
              />
              <HelpBlock>{this.state.messageError ? "Please enter a message for Crowtech." : ''}</HelpBlock>
            </FormGroup>

            <Button type="submit">
              Submit
            </Button>
          </form>
        </Col> }
      </Row>      
    );
  }
}


// WEBPACK FOOTER //
// ./src/ui/pages/Contact.js